import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import useData from '../../hooks/useData'
import ElectionContext from '../../context/ElectionContext'
import LegislatureResults from './LegislatureResults'
import { API_ENDPOINT } from '../../config'
import { MN_SENATE_DISTRICT_PATTERN } from '../../util'
import usePreviousElection from '../../hooks/usePreviousElection'

const MnSenate = () => {
  const context = useContext(ElectionContext)
  const { slug } = useParams()
  const previousElection = usePreviousElection(
    context,
    'legislature',
    'mn_senate_races'
  )
  let isSlugGood = MN_SENATE_DISTRICT_PATTERN.test(slug)
  let url = `${API_ENDPOINT}/${context.date}/mn_senate_races`
  let slugUrl = isSlugGood ? `${url}/${slug}` : url

  const data = useData(slugUrl, 30000)

  return (
    <div className="Legislature">
      <Helmet>
        <title>MPR News | Live Results for MN Senate</title>
        <meta
          name="twitter:title"
          content="LIVE Election Results from MPR News | MN Senate"
        />
        <meta
          name="twitter:title"
          content="LIVE Election Results from MPR News | MN Senate"
        />
        <meta
          property="og:title"
          content="LIVE Election Results from MPR News | MN Senate"
        />
      </Helmet>
      <div className="section_header">
        <h2 className="hdg hdg-2 mobileCentered">Minnesota Senate Results</h2>
      </div>
      <LegislatureResults
        data={data}
        mapTag="mnSenate"
        url={url}
        name="Minnesota Senate"
        previousElection={previousElection}
      />
    </div>
  )
}

export default MnSenate
